// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"42225d46","193":"ec3783b6","225":"a19d8801","264":"f96b0b74","366":"988a8548","424":"57ed3889","464":"9b55710e","643":"f47882dd","771":"2694109e","838":"232315db","957":"14584181","962":"f120fb37","966":"47046a22","981":"f475528d"}[chunkId] + ".chunk.js";
};